import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { ObjectComponentCategory } from '../../model/object-component-category';
import { ObjectComponentCategoryService } from '../../service/data/object-component-category.service';
import { ObjectComponentCategoryCommandHandlerResolver } from '../../service/command/object-component-category-command-handler-resolver.service';

@Component({
    selector: 'app-object-component-category-manager',
    templateUrl: './../../../core/component/multiselect-object-manager/multiselect-object-manager.template.html',
    styleUrls: ['./../../../core/component/multiselect-object-manager/multiselect-object-manager.component.scss'],
    providers: [ObjectComponentCategoryCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ObjectComponentCategoryManagerComponent extends MultiselectObjectManagerComponentBase<ObjectComponentCategory> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    dataService: ObjectComponentCategoryService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: ObjectComponentCategoryCommandHandlerResolver
  ) {
    super(dataService, dispatcher, handlerResolver, messageService, navigationService);
    this.columnDefinition = columnDefinitionService.create('ObjectComponentCategory');
    this.title = 'COMPONENT.COMPONENT_CATEGORIES';
    this.preferencesKey = 'rent.object-component-category.list';
  }
}
